import React from "react";
import styles from "./Footer.module.css";

interface FooterProps {
  companyName: string;
}

const Footer: React.FC<FooterProps> = ({ companyName }) => {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.footerColumn}>
            <h3 className={styles.columnTitle}>{companyName}</h3>
            <p className={styles.companyDescription}>
              Techpioneers prime objectives are to supply support to all our
              clients with highest standards of workmanship, integrity, safety
              and reliability.
            </p>
            <div className={styles.socialIcons}>
              <a
                href="https://www.linkedin.com/company/techpioneers-projects"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in" />
              </a>
              {/* <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter" />
              </a>
              <a href="#" aria-label="Instagram">
                <i className="fab fa-instagram" />
              </a>
              <a href="#" aria-label="YouTube">
                <i className="fab fa-youtube" />
              </a> */}
            </div>
          </div>

          <div className={styles.footerColumn}>
            <h3 className={styles.columnTitle}>Quick Links</h3>
            <div className={styles.footerLinks}>
              <a href="#home">Home</a>
              <a href="#services">Services</a>
              <a href="#projects">Projects</a>
              <a href="#careers">Careers</a>
            </div>
          </div>

          <div className={styles.footerColumn}>
            <h3 className={styles.columnTitle}>Contact</h3>
            <div className={styles.contactInfo}>
              <p>
                <i className="fas fa-envelope" /> thulanit@techpioneers.co.za
              </p>
              <p>
                <i className="fas fa-phone" /> +27 13 110 3787/+27 72 535 8330
              </p>
              <p>
                <i className="fas fa-map-marker-alt" /> Cornerstone Office Park
                |
                <br />
                43 SADC Street, Middelburg, 1050,
                <br />
                Mpumalanga, South Africa
              </p>
            </div>
          </div>
        </div>

        <div className={styles.copyright}>
          &copy; 2021 Techpioneers Projects (PTY) LTD. All rights reserved. |
          Privacy Policy | Terms of Service
        </div>

        <div className={styles.developer}>
          Developed by Consulsion (Pty) Ltd. &nbsp;
          <a
            href="https://www.consulsion.co.za"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-link" /> www.consulsion.co.za
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
